import { apiSlice } from "features/api/apiSlice";

const callDoctor = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    callDoctor: build.mutation({
      query: (body) => ({
        url: "/appointments/oncall/request",
        method: "POST",
        body,
      }),
      transformResponse: (res) => res.d.appointments.id,
      invalidatesTags: (result) => {
        if (result) {
          return [
            { type: "Doctor", id: result.practitioner.id },
            "Appointment",
            "Voucher",
          ];
        }
      },
    }),
  }),
});

export const { useCallDoctorMutation } = callDoctor;
